export const CURRENCY = {
    USD: { value: 'USD', symbol: '$' },
    EUR: { value: 'EUR', symbol: '€' },
    GBP: { value: 'GBP', symbol: '£' },
    CHF: { value: 'CHF', symbol: '₣' }, // Swiss Franc
    CAD: { value: 'CAD', symbol: 'Can$' }, // Canadian Dollar
};
export const CURRENCY_OPTIONS = {
    USD: {
        key: 'usd',
        label: `${CURRENCY.USD.symbol}/hr`,
        value: CURRENCY.USD.value,
    },
    EUR: {
        key: 'euro',
        label: `${CURRENCY.EUR.symbol}/hr`,
        value: CURRENCY.EUR.value,
    },
    GBP: {
        key: 'gbp',
        label: `${CURRENCY.GBP.symbol}/hr`,
        value: CURRENCY.GBP.value,
    },
    CHF: {
        key: 'chf',
        label: `${CURRENCY.CHF.symbol}/hr`,
        value: CURRENCY.CHF.value,
    },
    CAD: {
        key: 'cad',
        label: `${CURRENCY.CAD.symbol}/hr`,
        value: CURRENCY.CAD.value,
    },
};

export const ADDRESS_PLACEHOLDER = 'e.g Apt 24, 1st Block, Cross Street';

export const StepperStatusEnum = {
    INCOMPLETE: 'INCOMPLETE',
    COMPLETED: 'COMPLETED',
    ACTIVE: 'ACTIVE',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
};
